var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConfirmModal',_vm._b({attrs:{"color":"primary","icon":"mdi-logout","maxWidth":500,"setTitle":_vm.setTitle,"setQuestion":_vm.setQuestion,"confirmData":_vm.logoutData},on:{"onConfirm":_vm.onLogout}},'ConfirmModal',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }